import BaseModel from '@/data/BaseModel';

export interface RipplingPayPeriodFields {
  startDate: string;
  endDate: string;
  paySchedule: string;
}

export class RipplingPayPeriod extends BaseModel<RipplingPayPeriodFields>({
  startDate: '',
  endDate: '',
  paySchedule: '',
}) {}

export enum RipplingPayrollRunState {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  FAILED = 'FAILED',
  CLOSED = 'CLOSED',
}

export interface RipplingPayrollRunFields {
  id: string;
  runType: RipplingPayrollRunState;
  checkDate: string;
  name: string;
  approvalDeadline: string;
  approvedAt: string;
  payPeriod: RipplingPayPeriod;
  uri: string;
}

export class RipplingPayrollRun extends BaseModel<RipplingPayrollRunFields>({
  id: '',
  runType: RipplingPayrollRunState.DRAFT,
  checkDate: '',
  name: '',
  approvalDeadline: '',
  approvedAt: '',
  payPeriod: new RipplingPayPeriod({}),
  uri: '',
}) {}
